import React, { useContext, useEffect } from "react";
import { StyleSheet, View, Text } from "react-native";

import Screen from "~/layouts/Screen/index.web";
import SidePanel from "~/components/SidePanel";
import Row from "~/layouts/Row";
import Col from "~/layouts/Col";

import useTwilio from "~/hooks/useTwilio";
import CallLogList from "~/components/CallLogList/index.web";
import CallsHeader from "~/components/Headers/CallsHeader/index.web";
import DialerPanel from "~/components/Dialer/Panel/index.web";
import ActiveCallPanel from "~/screens/ActiveCallScreen/Panel/index.web";

import { CallsProvider } from "~/contexts/CallsContext";
import palette from "~/styles/palette";
import { BadgeContext } from "~/contexts/BadgeContext";

export default function CallsScreen({}) {
  const { calls, voicemails, messages } = useContext(BadgeContext);

  const { activeCall } = useTwilio();

  return (
    <CallsProvider>
      <Screen safeArea>
        <Row style={[styles.container]}>
          <SidePanel />
          <Col>
            <CallsHeader />
            <Row style={[styles.inner]}>
              <Col maxWidth={372} style={[styles.listPanel]}>
                <CallLogList />
              </Col>
              <Col style={[styles.centerPanel]}>
                <View>
                  <Text style={[styles.greeting]}>Hi!</Text>
                </View>
                <Text style={[styles.text]}>
                  {" "}
                  You have{" "}
                  {!!messages && (
                    <Text>
                      {messages} unread message{messages > 1 ? "s" : ""}
                    </Text>
                  )}
                  {!!messages && !!calls && !!voicemails && (
                    <>
                      {", "}
                      <br />
                    </>
                  )}
                  {!!messages && !!calls && !voicemails && (
                    <>
                      <br /> {"and "}
                    </>
                  )}
                  {!!calls && (
                    <>
                      <Text>
                        {calls} missed call{calls > 1 ? "s" : ""}
                      </Text>
                      <br />
                    </>
                  )}
                  {(!!calls || !!messages) && " and "}
                  {!!voicemails && <Text>{voicemails} new voicemails</Text>}
                </Text>
              </Col>
              <Col maxWidth={500} style={[styles.rightPanel]}>
                {activeCall ? <ActiveCallPanel /> : <DialerPanel />}
              </Col>
            </Row>
          </Col>
        </Row>
      </Screen>
    </CallsProvider>
  );
}

const styles = StyleSheet.create({
  greeting: {
    textAlign: "center",
    fontSize: 30,
  },
  text: {
    textAlign: "center",
    fontSize: 18,
    color: palette.grey,
  },
  listPanel: {
    borderRightWidth: 1,
    borderRightColor: palette.light_grey,
    height: "100%",
  },
  rightPanel: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  centerPanel: {
    borderRightWidth: 1,
    borderRightColor: palette.light_grey,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    minWidth: 380,
    height: "100%",
  },
  container: {
    flex: 1,
  },
  inner: {
    height: "calc(100% - 75px)",
  },
});
